module.exports = __webpack_public_path__ + "static/media/icon-price.d11bf136.svg";